export const convertObjectBodyString = (dataObject) =>
  Object.entries(dataObject)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');
